import { render, staticRenderFns } from "./MoralStudentEducation.vue?vue&type=template&id=6421648e&scoped=true&"
import script from "./MoralStudentEducation.vue?vue&type=script&lang=js&"
export * from "./MoralStudentEducation.vue?vue&type=script&lang=js&"
import style0 from "./MoralStudentEducation.vue?vue&type=style&index=0&id=6421648e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421648e",
  null
  
)

export default component.exports